
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexMrkRSrjtuLGkYQSDtNWui5gMZbFDs8s8MoJcbZA7UB0Meta } from "/opt/atlassian/pipelines/agent/build/layers/planned-deliveries/pages/planned-deliveries/failures/index.vue?macro=true";
import { default as _91prescription_id_93F_4LaXoEjBHVV1yx5Yily6flby94G6NAI63QyJhchSUMeta } from "/opt/atlassian/pipelines/agent/build/pages/pdf/[prescription_id].vue?macro=true";
import { default as apro_45proxyTs2AzvWIAXmF_KZY6lXvhsZCaZVSlfoK2_Gh_Mr56VsMeta } from "/opt/atlassian/pipelines/agent/build/layers/apro-proxy/pages/apro-proxy.vue?macro=true";
import { default as inloggenwHLDgWyIMgJrtRcOlOPfaWvorHcLv_HZktyh_QMguxUMeta } from "/opt/atlassian/pipelines/agent/build/pages/inloggen.vue?macro=true";
import { default as loginfD_rUPL4hV4jhtvGKktR51FF7i0qHNkHLcUE7hZavoAMeta } from "/opt/atlassian/pipelines/agent/build/pages/login.vue?macro=true";
import { default as indexp0hCpDuItG3FuLerFqm4xx0ViRQbQzB569HMrF4xUXkMeta } from "/opt/atlassian/pipelines/agent/build/layers/planned-deliveries/pages/planned-deliveries/index.vue?macro=true";
export default [
  {
    name: "planned-deliveries-anomalies",
    path: "/planned-deliveries/anomalies",
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/planned-deliveries/pages/planned-deliveries/anomalies.vue")
  },
  {
    name: "planned-deliveries-failures",
    path: "/planned-deliveries/failures",
    meta: indexMrkRSrjtuLGkYQSDtNWui5gMZbFDs8s8MoJcbZA7UB0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/planned-deliveries/pages/planned-deliveries/failures/index.vue")
  },
  {
    name: "planned-deliveries-userId-deliveryId",
    path: "/planned-deliveries/:userId()/:deliveryId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/planned-deliveries/pages/planned-deliveries/[userId]/[deliveryId].vue")
  },
  {
    name: "dispense-guidance-dispenseGuidanceId",
    path: "/dispense-guidance/:dispenseGuidanceId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/dispense-guidance/pages/dispense-guidance/[dispenseGuidanceId].vue")
  },
  {
    name: "pdf-prescription_id",
    path: "/pdf/:prescription_id()",
    meta: _91prescription_id_93F_4LaXoEjBHVV1yx5Yily6flby94G6NAI63QyJhchSUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/pdf/[prescription_id].vue")
  },
  {
    name: "planned-deliveries-userId",
    path: "/planned-deliveries/:userId()",
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/planned-deliveries/pages/planned-deliveries/[userId]/index.vue")
  },
  {
    name: "accounts",
    path: "/accounts",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/accounts.vue")
  },
  {
    name: "apothekers-controle",
    path: "/apothekers-controle",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/apothekers-controle.vue")
  },
  {
    name: "apro-proxy",
    path: "/apro-proxy",
    meta: apro_45proxyTs2AzvWIAXmF_KZY6lXvhsZCaZVSlfoK2_Gh_Mr56VsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/apro-proxy/pages/apro-proxy.vue")
  },
  {
    name: "bestanden-inladen",
    path: "/bestanden-inladen",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/bestanden-inladen.vue")
  },
  {
    name: "bestellingen",
    path: "/bestellingen",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/bestellingen.vue")
  },
  {
    name: "callable",
    path: "/callable",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/callable.vue")
  },
  {
    name: "controle-levering",
    path: "/controle-levering",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/controle-levering.vue")
  },
  {
    name: "controle-profiel",
    path: "/controle-profiel",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/controle-profiel.vue")
  },
  {
    name: "dispense-guidance",
    path: "/dispense-guidance",
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/dispense-guidance/pages/dispense-guidance/index.vue")
  },
  {
    name: "facturen",
    path: "/facturen",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/facturen.vue")
  },
  {
    name: "gds-planning",
    path: "/gds-planning",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/gds-planning.vue")
  },
  {
    name: "inloggen",
    path: "/inloggen",
    meta: inloggenwHLDgWyIMgJrtRcOlOPfaWvorHcLv_HZktyh_QMguxUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/inloggen.vue")
  },
  {
    name: "intake-gesprek",
    path: "/intake-gesprek",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/intake-gesprek.vue")
  },
  {
    name: "klantprofiel",
    path: "/klantprofiel",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/klantprofiel.vue")
  },
  {
    name: "leveringen-overzicht",
    path: "/leveringen-overzicht",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/leveringen-overzicht.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginfD_rUPL4hV4jhtvGKktR51FF7i0qHNkHLcUE7hZavoAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "nazendingen",
    path: "/nazendingen",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/nazendingen.vue")
  },
  {
    name: "parallel-bestellen",
    path: "/parallel-bestellen",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/parallel-bestellen.vue")
  },
  {
    name: "partner-inschrijving",
    path: "/partner-inschrijving",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/partner-inschrijving.vue")
  },
  {
    name: "planned-deliveries",
    path: "/planned-deliveries",
    meta: indexp0hCpDuItG3FuLerFqm4xx0ViRQbQzB569HMrF4xUXkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/layers/planned-deliveries/pages/planned-deliveries/index.vue")
  },
  {
    name: "planning-aanpassingen",
    path: "/planning-aanpassingen",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/planning-aanpassingen.vue")
  },
  {
    name: "printen",
    path: "/printen",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/printen.vue")
  },
  {
    name: "receptverwerking-paginated",
    path: "/receptverwerking-paginated",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/receptverwerking-paginated.vue")
  },
  {
    name: "wijzigingen",
    path: "/wijzigingen",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/wijzigingen.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  }
]